import "./index.scss";
import {marked} from 'marked';

import * as React from "react";
import {useNavigate} from "react-router-dom";

import {Context} from "../../../context/dataStore";
import {Context_role} from "../../../context/rolesStore";
import {BandLayout, Checkbox} from "../../../components";
import {BCFP_ROLES_ARR} from "../../../constants/global";
import { BFCP_LIVE, LEGAL_NOTICE} from "../../../constants/reminder";
import { CATEGORY_REMINDER } from "../../../constants/reminder";
import {ORG_LEGAL_TERMS_ACCEPTED} from '../../../constants/events';
import { getRefValue } from '../../../utils/utils';



const LegalNoticePage = () => {
  let navigate = useNavigate();
  const { postEvents, updateLegalNotice, dispatch, state: {reminderData, metaDataAboutUser, ...other}} = React.useContext(Context);
  const { decodePayload, state: {newroles} } = React.useContext(Context_role);
  //is bfcp live
  const [is_BCFP_LIVE, set_BCFP_LIVE] = React.useState("");
  //used to modify the continue button
  const [isDisabled, setDisabled] = React.useState(true);
 // const [scrolledfinished, setScrollFinished] = React.useState(false);
  //used for accessibility
  // const [scrollvalue, setScrollValues] = React.useState({
  //   scrollHeight: 0,
  //   scrollTop: 0,
  //   clientHeight: 0
  // });
  
  React.useEffect(() => reminderData?.forEach(el => {
    if(el.code===BFCP_LIVE) {
      set_BCFP_LIVE(`${el.value}`);
    }
    if(el.code===LEGAL_NOTICE) {
      document.getElementById('scrolltext').innerHTML = marked(`${el.value}`);
    }
  }), [reminderData]);

  // React.useEffect(() => {
  //   const elem = document.getElementById("scrollborder");
  //   elem.addEventListener("scroll", function(event) {
  //     let element = event.target;
  //     setScrollValues({...scrollvalue, scrollHeight:parseInt(element.scrollHeight), scrollTop:parseInt(element.scrollTop), clientHeight:parseInt(element.clientHeight)});
  //     if (parseInt(element.scrollHeight - element.scrollTop) === element.clientHeight)
  //     {
  //       setScrollFinished(true);
  //     }
  //   });
  //   elem.removeEventListener("scroll", function() {
  //     setScrollFinished(false);
  //   });
  // }, [scrollvalue]);
 // ---REDIRECT WHEN LIVE
  //--'false' means we are not live so BLOCK OUR APP
  if(is_BCFP_LIVE==="false" && BCFP_ROLES_ARR.includes(newroles[0])) {
    navigate('/bfcp_is_ready_comingsoon');
  }

  const academicYear = getRefValue(reminderData, 'AY');

  return(
    <div>
      <div style={{marginBottom: "20px", display: "none"}}>
        <BandLayout metaData={CATEGORY_REMINDER} metaData_OrgName={`${metaDataAboutUser.orgName}`} />
      </div>
      <div className='legalContainer'>
        <div id='header1text' role="heading" aria-level="1">Hello {metaDataAboutUser.orgName}</div>
        <div id='header2text' role="heading" aria-level="2">
          Please review and accept the BigFuture College Profile Terms of Use. Use the checkbox to indicate that you accept them. You must accept all of the Terms of use in order to access the BigFuture College Profile.
        </div>
        <div id='scrollborder' tabIndex='0' className='scroll-bar' role='scrollbar' 
        aria-labelledby='header2text' aria-describedby='scrolltext' aria-controls='scrollborder' aria-orientation='vertical'>
          <span id='scrolltext' role="heading" aria-level="3" />
        </div>
        <div className='btnAlignment'>
          <Checkbox checkboxId='confirmationCheck' checkboxName='confirmationCheck'
            checkboxValue='I agree to the Terms of Use' onChangecheckboxValue={e => setDisabled(!e.target.checked)}
            org_rol={newroles[0]} statusOfModule={false} />
          <button id='termsndusebtn' type='button' disabled={isDisabled} onClick={async() => {
                const id = metaDataAboutUser.orgId; const rol_num = metaDataAboutUser.org_role;
                await updateLegalNotice(id, {"is_legal_notice": true });
                const decodeToken = decodePayload(cb.core.iam.getJWTToken());
                await postEvents({
                  event_type: ORG_LEGAL_TERMS_ACCEPTED,
                  event_data: {
                    userName: decodeToken.cb.un, 
                    email: decodeToken.cb.em, 
                    acceptedTime: new Date(), 
                    orgId: id,
                    academicYear: Number(academicYear),
                  },
                  last_updated_at: new Date(),
                  last_updated_by: decodeToken.cb.un
                });
                dispatch({type:"UPDATE_METADATA", payload: {...metaDataAboutUser, legalNotice: true}});
                navigate(`/organizations/${id}/categories/0/${rol_num}`);
              }} className='cb-btn cb-btn-primary' aria-label='Accept terms and conditions'>
            <span id='termsndusebtn_text'>
              Continue
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default LegalNoticePage;